<script setup>
// A moldura de uma tela de campanhas (planta do kit: AreaPage): o cabeçalho da página com o botão de criar, o corpo
// que rola e, ao lado, a gaveta de criar/editar (slot `drawer`: a gaveta é coluna a partir de 1280 px, sobreposição
// abaixo disso, e por isso mora na mesma linha do conteúdo).
import { Add16 } from '@carbon/icons-vue';
import PageHeader from 'dashboard/components-next/polaris/cards/PageHeader.vue';
import { Button } from 'dashboard/components-next/polaris/ui/button';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click']);
</script>

<template>
  <section
    class="flex h-full min-h-0 w-full bg-polaris-background text-polaris-foreground"
  >
    <div class="flex min-w-0 flex-1 flex-col">
      <PageHeader :title="headerTitle">
        <template #actions>
          <Button
            type="button"
            size="sm"
            data-campaign-create
            @click="emit('click')"
          >
            <Add16 aria-hidden="true" />{{ buttonLabel }}
          </Button>
        </template>
      </PageHeader>
      <div class="min-h-0 flex-1 overflow-auto p-6">
        <div class="mx-auto grid w-full max-w-[100rem] gap-4">
          <slot name="default" />
        </div>
      </div>
    </div>
    <slot name="drawer" />
  </section>
</template>
